import React from 'react';
function MailCheck({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path
        d="M21.375 10.2154V5.99896C21.375 5.50195 21.1775 5.02531 20.8258 4.67387C20.4742 4.32243 19.9973 4.125 19.5 4.125H4.5C4.00272 4.125 3.52581 4.32243 3.17417 4.67387C2.82254 5.02531 2.625 5.50195 2.625 5.99896V17.2427C2.625 18.2734 3.46875 19.1167 4.5 19.1167H16.2188M21.375 6.93594L12.9656 12.2767C12.6762 12.458 12.3415 12.5541 12 12.5541C11.6585 12.5541 11.3238 12.458 11.0344 12.2767L2.625 6.93594M19.5 13.4948V17.2427M19.5 20.9906V21"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default MailCheck;
